var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_5208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5132 6.10352e-05L11.5023 6.77331L13.178 2.78164L20.5132 6.10352e-05Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.507814 0.00805664L7.82344 2.78214L9.41452 6.82614L0.507814 0.00805664ZM16.8869 14.4049L20.8696 14.4819L19.4777 19.2854L14.6179 17.9261L16.8869 14.4049ZM4.11292 14.4049L6.37346 17.9261L1.52188 19.2855L0.138428 14.4819L4.11292 14.4049Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19825 5.79606L9.361 11.1363L4.49072 10.9112L5.87607 8.78806L5.89362 8.76765L9.19825 5.79606ZM11.7513 5.73648L15.1064 8.76781L15.1238 8.78815L16.5091 10.9113L11.6399 11.1363L11.7513 5.73648ZM6.51616 14.4204L9.17545 16.5253L6.08631 18.0404L6.51616 14.4204ZM14.4843 14.4201L14.9052 18.0405L11.8247 16.5251L14.4843 14.4201Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8927 16.3269L15.0187 17.8646L12.1109 19.2684L12.1411 18.3406L11.8927 16.3269ZM9.10637 16.3276L8.86774 18.3254L8.88735 19.2673L5.97278 17.8646L9.10637 16.3276Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20374 11.8333L9.02061 13.5773L6.2395 12.7496L8.20374 11.8333ZM12.7963 11.8335L14.7698 12.7496L11.9796 13.5771L12.7963 11.8335Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72866 14.4026L6.27913 18.1559L3.86963 14.4846L6.72866 14.4026ZM14.2714 14.4026L17.1306 14.4846L14.712 18.1561L14.2714 14.4026ZM16.5795 10.699L14.4987 12.8532L12.8945 12.1085L12.1264 13.7488L11.6229 10.9281L16.5795 10.699ZM4.4194 10.699L9.37696 10.9281L8.87337 13.7488L8.10515 12.1087L6.50939 12.8533L4.4194 10.699Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2793 10.2569L6.63343 12.6836L6.71497 15.0794L4.2793 10.2569ZM16.7232 10.2526L14.2831 15.0836L14.375 12.6836L16.7232 10.2526ZM9.26196 10.4047L9.3567 11.0106L9.59082 12.5198L9.44029 17.1552L8.72867 13.4315L8.72843 13.393L9.26196 10.4047ZM11.7369 10.3963L12.2718 13.393L12.2716 13.4315L11.5582 17.1646L11.53 16.2308L11.4186 12.4923L11.7369 10.3963Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5842 12.5872L14.5045 14.6687L12.0211 16.6343L11.5191 16.274L12.0818 13.3294L14.5842 12.5872ZM6.42444 12.5872L8.91811 13.3294L9.48084 16.274L8.97881 16.6343L6.49531 14.6686L6.42444 12.5872Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49756 17.4049L8.67479 18.9342L8.66134 18.2812L8.9272 18.0441H12.0718L12.3472 18.2803L12.3269 18.9329L15.484 17.4087L13.9478 18.6984L12.0902 19.9945H8.90169L7.04532 18.6931L5.49756 17.4049Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6652 16.1233L12.1144 16.4457L12.3776 18.5794L11.9966 18.2527H9.00447L8.63074 18.586L8.88536 16.4459L9.33473 16.1233H11.6652Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9183 0.187561L21 3.48398L20.3245 6.81706L20.8055 7.19398L20.1546 7.69848L20.6438 8.08231L19.996 8.68156L20.3937 8.97414L19.3383 10.2263L15.0095 8.94589L14.972 8.92548L11.8526 6.25231L19.9183 0.187561ZM1.08166 0.187561L9.14747 6.25231L6.02798 8.92548L5.9905 8.94589L1.66171 10.2263L0.606293 8.97414L1.00365 8.68181L0.356262 8.08231L0.844512 7.69889L0.183832 7.19298L0.682992 6.81581L0 3.48414L1.08166 0.187561Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7978 8.6659L19.3844 10.0225L20.8745 14.688H16.9432L14.2346 14.7227L16.2044 10.822L14.7978 8.6659ZM6.20222 8.6659L4.7953 10.822L6.76544 14.7227L4.058 14.688H0.133789L1.61552 10.0226L6.20222 8.6659ZM13.4026 2.7594L12.1197 6.27932L11.8474 11.0343L11.7433 12.5247L11.735 16.3321H9.26493L9.2569 12.5319L9.15239 11.0331L8.88004 6.27932L7.59732 2.7594H13.4026Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_5208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask-icon.c232797135ea066d9abf13440fd849c6.svg";
export { ForwardRef as ReactComponent };